//material-ui
import { styled } from "@mui/material/styles";

// third-party
import { SnackbarProvider } from "notistack";

// project imports
import Loader from "components/Loader";
import { useGetSnackbar } from "api/snackbar";

// assets
import { CheckCircleOutlined } from "@ant-design/icons";
import { CloseCircleOutlined } from "@ant-design/icons";
import { InfoCircleOutlined } from "@ant-design/icons";
import { WarningOutlined } from "@ant-design/icons";

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  "&.notistack-MuiContent-default": {
    background: theme.palette.primary.main,
  },
  "&.notistack-MuiContent-error": {
    background: theme.palette.error.main,
  },
  "&.notistack-MuiContent-success": {
    background: theme.palette.success.main,
  },
  "&.notistack-MuiContent-info": {
    background: theme.palette.info.main,
  },
  "&.notistack-MuiContent-warning": {
    background: theme.palette.warning.main,
  },
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }: any) {
  const { snackbar } = useGetSnackbar();
  const iconSX = { marginRight: 8, fontSize: "1.15rem" };

  if (snackbar === undefined) return <Loader />;

  return (
    <StyledSnackbarProvider
      maxSnack={snackbar.maxStack}
      dense={snackbar.dense}
      iconVariant={
        snackbar.iconVariant === "useemojis"
          ? {
              success: <CheckCircleOutlined style={iconSX} />,
              error: <CloseCircleOutlined style={iconSX} />,
              warning: <WarningOutlined style={iconSX} />,
              info: <InfoCircleOutlined style={iconSX} />,
            }
          : undefined
      }
      hideIconVariant={snackbar.iconVariant === "hide" ? true : false}
    >
      {children}
    </StyledSnackbarProvider>
  );
}
